import React, { Component } from 'react'
import PropTypes from 'prop-types'
import BlockWithLoader from '../Support/BlockWithLoader'
import JobInfoBox from './JobInfoBox'
import _ from 'lodash'
import { Query, Mutation } from 'react-apollo'
import { Button } from 'reactstrap'
import ConfirmModal from '../Alerts/ConfirmModal'
import { GET_JOBS, JOB_SUBSCRIPTION, JOBS_NOTIFY_OFF } from './graphql'
import gql from 'graphql-tag'

const VisibleOffJobs = gql`
  mutation visibleOffJobs($id: ID!) {
    visibleOffJobs(id: $id) {
      response
    }
  }
`

const propTypes = {
  data: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  error: PropTypes.object,
  subscribeToNewJobs: PropTypes.func.isRequired,
  notifyOffJobs: PropTypes.func.isRequired,
  visibleOffJobsMutation: PropTypes.func.isRequired,
  shouldRender: PropTypes.bool.isRequired
}

class JobsList extends Component {
  constructor() {
    super()
    this.state = {
      notifiedOffJobs: [],
      disableAllAlert: false,
      hiddenJobs: []
    }
    this.toggleDisableAllAlert = this.toggleDisableAllAlert.bind(this)
    this.disableAllVisibility = this.disableAllVisibility.bind(this)
  }

  componentDidMount() {
    this.props.subscribeToNewJobs()
  }

  componentWillReceiveProps(nextProps) {
    if (!nextProps.loading && nextProps.data) {
      const newNotifyJobs = _.filter(nextProps.data.user_jobs, o => o.notify).map(o => o.id)
      if (nextProps.shouldRender) {
        if (newNotifyJobs.length > 0 && (_.difference(newNotifyJobs, this.state.notifiedOffJobs)).length > 0) {
          this.setState({ notifiedOffJobs: newNotifyJobs }, () => this.props.notifyOffJobs().then(() => this.changeNotifyCountEvent(0)))
        }
      } else {
        this.changeNotifyCountEvent(newNotifyJobs.length)
      }
    }
  }

  changeNotifyCountEvent(count) {
    const event = new CustomEvent('changeNotifyCountInApp', { 'detail': { 'notifyCount': count } })
    window.dispatchEvent(event)
  }

  toggleDisableAllAlert() {
    this.setState({ disableAllAlert: !this.state.disableAllAlert })
  }

  async disableAllVisibility() {
    this.toggleDisableAllAlert()
    
    const visibleJobs = this.props.data.user_jobs.filter(job => job.visible && !this.state.hiddenJobs.includes(job.id))
    
    for (const job of visibleJobs) {
      try {
        const result = await this.props.visibleOffJobsMutation({
          variables: { id: job.id }
        })
        
        if (result) {
          this.setState(prevState => ({
            hiddenJobs: [...prevState.hiddenJobs, job.id]
          }))
        }
      } catch (error) {
        console.error('Error hiding job:', error)
      }
    }
  }

  render() {
    if (!this.props.shouldRender) return null
    if (this.props.error) return <div>An unexpected error occurred</div>

    const visibleJobs = this.props.data.user_jobs ? this.props.data.user_jobs.filter(job => job.visible && !this.state.hiddenJobs.includes(job.id)) : []

    return (
      <BlockWithLoader loading={this.props.loading}>
        <ConfirmModal
          isOpened={this.state.disableAllAlert}
          onCancel={this.toggleDisableAllAlert}
          onConfirm={this.disableAllVisibility}
          headerText='Disable Visibility All'
          bodyText='Are you sure you want to disable visibility for all jobs?'
          confirmBtnText='Disable All'
        />
        {visibleJobs.length > 0 && (
          <div style={{ textAlign: 'center', marginBottom: '1rem' }}>
            <Button
              color="danger"
              size="sm"
              onClick={this.toggleDisableAllAlert}
            >
              Disable visibility all
            </Button>
          </div>
        )}
        {visibleJobs.map(job => (
          <JobInfoBox key={job.id} job={job} />
        ))}
      </BlockWithLoader>
    )
  }
}

JobsList.propTypes = propTypes

const JobsMain = ({ shouldRender }) => (
  <Query query={GET_JOBS}>
    {({ subscribeToMore, ...result }) => {
      return (
        <Mutation mutation={JOBS_NOTIFY_OFF}>
          {notifyOffJobs =>
            <Mutation mutation={VisibleOffJobs}>
              {visibleOffJobsMutation =>
                <JobsList
                  {...result}
                  notifyOffJobs={notifyOffJobs}
                  visibleOffJobsMutation={visibleOffJobsMutation}
                  shouldRender={shouldRender}
                  subscribeToNewJobs={() =>
                    subscribeToMore({
                      document: JOB_SUBSCRIPTION,
                      updateQuery: (prev, { subscriptionData }) => {
                        if (!subscriptionData.data) return prev
                        const newFeedItem = subscriptionData.data.newJob
                        const itemAlreadyInStore = prev.user_jobs.find(o => o.id === newFeedItem.id)

                        if (!itemAlreadyInStore) {
                          return Object.assign({}, prev, {
                            user_jobs: [newFeedItem, ...prev.user_jobs]
                          })
                        }
                      }
                    })
                  }
                />
              }
            </Mutation>
          }
        </Mutation>
      )
    }}
  </Query>
)

JobsMain.propTypes = {
  shouldRender: PropTypes.bool.isRequired
}

export default JobsMain



// WEBPACK FOOTER //
// ./src/components/JobsNotifications/JobsMain.js